import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { orderBy, process, State, SortDescriptor } from '@progress/kendo-data-query';
import { Info } from '../../../../../core/common';
import { AdminService } from '../../../../../core/services/admin.service';
import { LanguageTranslationService } from '../../../../../core/services/language-translation.service';

import { Subject } from 'rxjs';
import { AppNotifyService } from '../../../../../core/services/app-notify.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';
@Component({
  selector: 'app-survey-admin',
  templateUrl: './survey-admin.component.html',
  styleUrls: ['./survey-admin.component.scss']
})
export class SurveyAdminComponent implements OnInit {
  //#region member variable
  surveyQuestionGridView: GridDataResult;
  surveyLoading: boolean;
  surveyForm: FormGroup;
  saveInProcess: boolean;
  public infoMessage: Info = new Info();
  public inProgressMessage: boolean;
  public successMessage: boolean;
  public errorMessage: boolean;
  getLanguages: any;
  selectedLanguage: string;
  //#endregion
  constructor(private formBuilder: FormBuilder, private adminService: AdminService, private languageService: LanguageTranslationService,
    private appNotifyService: AppNotifyService,

  ) { }

  ngOnInit() {
    this.loadSurveyQuestionGrid();
    this.surveyForm = this.formBuilder.group({
      surveyId: new FormControl(),
      question: new FormControl(),
      languageCode: new FormControl(""),
      isActive: new FormControl(),
    })
    this.languageService.getLanguages().subscribe(response => {
      this.getLanguages = response;
    })
  }

  loadSurveyQuestionGrid() {
    this.surveyLoading = true;
    const body = {
      languageCode: ""
    }
    this.adminService.getSurveyDetails(body).subscribe((response) => {
      this.bindSurveyGrid();
      this.surveyLoading = false;
    });
  }


  //#region label and variable declaration
  survey = {
    questionLbl: "Questions",
    actionLbl: "Action",
    addSurveyQuestionLbl: "Add Survey Question",
    closeLbl: "Close",
    saveLbl: "Save",
    languageLbl: "Language",
    isActive: "Active",
    isSubmitted: false,
    isEmptyLanguage: false,
    isEmptyQuestions: false,
  }
  //#endregion
  //#region pagination, sorting,filtering for grid

  public surveyGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'surveyId',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };
  public bindSurveyGrid(): void {
    const data = this.adminService.surveyQuestions;
    this.surveyQuestionGridView = process(data, this.surveyGridstate);
  }

  public surveyGridSortChange(sort: SortDescriptor[]): void {
    this.surveyGridstate.sort = sort;
    this.bindSurveyGrid();
  }
  public surveyGridPageChange({ skip, take }: PageChangeEvent): void {
    this.surveyGridstate.skip = skip;
    this.surveyGridstate.take = take;
    this.bindSurveyGrid();
  }

  public surveyDataStateChange(state: DataStateChangeEvent): void {
    this.surveyGridstate = state;
    this.bindSurveyGrid();
  }
  //#endregion

  //#region survey dialog operation

  surveyDialog = {
    opened: false,
  }
  toggleSurveyDialog() {
    this.surveyDialog.opened = !this.surveyDialog.opened;
    // if (this.surveyDialog.opened == false) {
    this.resetSurveyForm();
    //}
  }

  editSurveyDetails(data: any) {
    this.surveyDialog.opened = !this.surveyDialog.opened;
    this.surveyForm.controls.surveyId.setValue(data.surveyId);
    this.surveyForm.controls.question.setValue(data.questions);
    this.selectedLanguage = data.languageCode;
    this.surveyForm.controls.languageCode.setValue(data.languageCode);
    this.surveyForm.controls.isActive.setValue(data.isActive);
  }

  resetSurveyForm() {
    this.surveyForm.reset();
    this.infoMessage = new Info();
    this.saveInProcess = false;
    this.selectedLanguage = "";
    this.survey.isSubmitted = false;
    this.survey.isEmptyLanguage = false;
    this.survey.isEmptyQuestions = false;
    this.surveyForm.controls.isActive.setValue(true);

  }

  public validateForm(): boolean {
    let isValid = true;
    const controls = this.surveyForm.controls;
    if (this.survey.isSubmitted) {
      const t = controls.languageCode.value ? controls.languageCode.value.languageCode : "";
      if (t) {
        this.survey.isEmptyLanguage = false;
      } else {
        this.survey.isEmptyLanguage = true;
        isValid = false;
      }

      if (controls.question.value) {
        this.survey.isEmptyQuestions = false;
      } else {
        this.survey.isEmptyQuestions = true;
        isValid = false;
      }

    }
    return isValid;
  }

  public saveSurveyDetails() {
    this.survey.isSubmitted = true;
    if (!this.validateForm()) {
      return;
    }
    var controls = this.surveyForm.controls;
    this.inProgressMessage = true;
    this.infoMessage.genericSuccess = "";
    this.infoMessage.genericError = "";
    this.infoMessage.genericInProgress = this.infoMessage.inProgressMessage;
    this.saveInProcess = true;
    const body = {
      surveyId: controls.surveyId.value ? controls.surveyId.value : 0,
      questions: controls.question.value,
      languageCode: controls.languageCode.value ? controls.languageCode.value.languageCode : "",
      isActive: controls.isActive.value ? controls.isActive.value : false,
    }
    this.adminService.saveSurveyDetails(body).subscribe((response: any) => {
      this.infoMessage.genericInProgress = "";
      this.saveInProcess = false;
      if (response) {
        this.resetSurveyForm();
        this.successMessage = true;
        this.infoMessage.genericSuccess = this.infoMessage.successMessage;
        this.bindSurveyGrid();
      } else {
        this.infoMessage.genericError = this.infoMessage.errorMessage;
      }
    })
  }
  //#endregion

  //#region delete item
  public gridItemToRemove: any;
  public removeConfirmationSubject: Subject<boolean> = new Subject<boolean>();

  gridDelete = {
    label: {
      deleteConfirmLbl: 'Are you sure you want to delete question ',
      deleteYesLbl: 'Yes',
      deleteNoLbl: 'No',
      confirmLbl: 'Please confirm',
    }
  }


  public removeConfirmation(dataItem): Subject<boolean> {
    this.gridItemToRemove = dataItem; // show delete item confirmation box
    return this.removeConfirmationSubject;
  }

  public confirmRemove(shouldRemove: boolean): void {
    if (shouldRemove) {
      this.removeConfirmationSubject.next(shouldRemove);
      this.RemoveHandler();
    }
    else {
      this.removeConfirmationSubject.next(shouldRemove);
      this.gridItemToRemove = null;
    }
  }
  public RemoveHandler() {
    this.adminService.deleteSurveyDetails(this.gridItemToRemove).subscribe((isRemoved: boolean) => {
      const surveyId = this.gridItemToRemove.surveyId;
      this.gridItemToRemove = null;
      this.appNotifyService.notify(NotifyType.SUCCESS, "Selected question has been removed.");

      if (this.adminService.surveyQuestions) {
        //This is a Local Remove
        const index = (this.adminService.surveyQuestions).findIndex(r => r.surveyId === surveyId);
        (this.adminService.surveyQuestions).splice(index, 1);
        this.bindSurveyGrid();

      }



    }, error => {
      this.appNotifyService.notify(NotifyType.ERROR, 'An Error Occured');
    });
  }

  //#endregion
}
